// Constantes de Inventario del Portal Admin VL: rótulos de la lista «Movimientos» del SKU.
import type {
    MovementCategory,
    MovementFilter,
    TransferStatus,
} from './lib/inventoryStockMovements';

/** Chips de filtro de la lista, en el orden en que se pintan. */
export const MOVEMENT_FILTERS: readonly MovementFilter[] = [
    'ALL',
    'SALE',
    'ENTRY',
    'ADJUSTMENT',
    'TRANSFER',
    'RETURN',
];

export const MOVEMENT_FILTER_LABEL: Record<MovementFilter, string> = {
    ALL: 'Todos',
    SALE: 'Ventas',
    ENTRY: 'Entradas',
    ADJUSTMENT: 'Ajustes',
    TRANSFER: 'Traspasos',
    RETURN: 'Devoluciones',
};

/** Tipo del renglón; apartado y liberación toman su rótulo del tipo crudo. */
export const MOVEMENT_CATEGORY_LABEL: Record<Exclude<MovementCategory, 'HOLD'>, string> = {
    SALE: 'Venta',
    ENTRY: 'Entrada',
    ADJUSTMENT: 'Ajuste',
    TRANSFER: 'Traspaso',
    RETURN: 'Devolución',
};

export const TRANSFER_STATUS_LABEL: Record<TransferStatus, string> = {
    IN_TRANSIT: 'en tránsito',
    RECEIVED: 'recibido',
    CANCELLED: 'cancelado',
};
